import { motion } from 'framer-motion';
import { useState } from 'react';

const Fleet = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const vehicles = [
    {
      type: 'Moto',
      title: 'Entregas Rápidas',
      image: 'https://public.readdy.ai/ai/img_res/0c380fc4597cb129a52a0a257c510cb9.jpg',
      specs: ['Entregas expressas', 'Documentos e malotes', 'Agilidade urbana', 'Até 20kg'],
    },
    {
      type: 'Carro',
      title: 'Médio Volume',
      image: 'https://readdy.ai/api/search-image?query=single%20white%20delivery%20sedan%20vehicle%20photographed%20from%20side%20angle%20on%20clean%20white%20studio%20background%20professional%20automotive%20photography%20with%20soft%20lighting%20representing%20efficient%20medium%20volume%20business%20logistics%20services%20minimal%20composition%20with%20clear%20vehicle%20details%20no%20overlapping%20elements&width=800&height=600&seq=rbf-fleet-sedan-studio-clean-2026&orientation=landscape',
      specs: ['Cargas médias', 'Múltiplas entregas', 'Conforto e segurança', 'Até 200kg'],
    },
    {
      type: 'Caminhão',
      title: 'Grande Volume',
      image: 'https://readdy.ai/api/search-image?query=professional%20delivery%20truck%20van%20with%20corporate%20branding%20representing%20large%20volume%20business%20logistics%20services%20for%20industrial%20and%20commercial%20cargo%20clean%20modern%20background&width=800&height=600&seq=rbf-fleet-003&orientation=landscape',
      specs: ['Grandes volumes', 'Longas distâncias', 'Cargas industriais', 'Acima de 200kg'],
    },
  ];

  return (
    <section id="frota" className="bg-white py-20">
      <div className="container mx-auto px-6 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-[#1a237e] mb-4">
            A Frota Ideal para Cada Tipo de Entrega
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Veículos modernos e bem mantidos para garantir a segurança e pontualidade das suas entregas
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl mb-8">
            <img
              src={vehicles[activeIndex].image}
              alt={vehicles[activeIndex].title}
              className="w-full h-96 object-cover"
            />
            <div className="absolute top-4 right-4 bg-[#ff6f00] text-white px-4 py-2 rounded-full font-bold">
              {vehicles[activeIndex].type}
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a237e]/95 to-transparent p-8">
              <h3 className="text-2xl font-bold text-white mb-4">{vehicles[activeIndex].title}</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {vehicles[activeIndex].specs.map((spec, idx) => (
                  <div key={idx} className="flex items-center text-white">
                    <i className="ri-checkbox-circle-fill text-[#ff6f00] mr-2"></i>
                    <span className="text-sm">{spec}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center space-x-4">
            <button
              onClick={() => setActiveIndex((prev) => (prev === 0 ? vehicles.length - 1 : prev - 1))}
              className="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-[#f8f9fa] transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl text-[#1a237e]"></i>
            </button>

            <div className="flex space-x-2">
              {vehicles.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIndex(idx)}
                  className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                    idx === activeIndex ? 'bg-[#ff6f00] w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={() => setActiveIndex((prev) => (prev === vehicles.length - 1 ? 0 : prev + 1))}
              className="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-[#f8f9fa] transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl text-[#1a237e]"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Fleet;
